import React from "react";

// Custom blue-line industrial process icons.
// Drawn with currentColor so they inherit the brand blue. Sit inside a light circle.
const base = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

const Wrap = ({ children }) => (
  <svg viewBox="0 0 48 48" width="100%" height="100%" {...base} aria-hidden="true">
    {children}
  </svg>
);

const Sandblasting = () => (
  <Wrap>
    <path d="M6 20h10l6-4v16l-6-4H6z" />
    <path d="M22 20l8-3M22 24h9M22 28l8 3" />
    <circle cx="36" cy="16" r="1.4" />
    <circle cx="40" cy="24" r="1.4" />
    <circle cx="36" cy="32" r="1.4" />
    <circle cx="42" cy="19" r="1.1" />
    <circle cx="42" cy="29" r="1.1" />
  </Wrap>
);

const ShotBlasting = () => (
  <Wrap>
    <circle cx="22" cy="24" r="10" />
    <path d="M22 24l6-5M22 24l6 5M22 24l-7 0M22 14v3M22 31v3" />
    <circle cx="22" cy="24" r="2.2" />
    <path d="M36 20l4-2M37 24h5M36 28l4 2" />
  </Wrap>
);

const Painting = () => (
  <Wrap>
    <path d="M14 10h8v8h-8z" />
    <path d="M18 18v6M12 24h12v6a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2z" />
    <path d="M22 12h10a2 2 0 0 1 2 2v6h-4" />
    <path d="M17 32v4" />
  </Wrap>
);

const Polyurea = () => (
  <Wrap>
    <path d="M10 30c3-3 6-3 9 0s6 3 9 0 6-3 9 0" />
    <path d="M10 36c3-3 6-3 9 0s6 3 9 0 6-3 9 0" />
    <path d="M20 12l4 4 4-4" />
    <path d="M24 8v8" />
    <circle cx="16" cy="20" r="1" />
    <circle cx="32" cy="20" r="1" />
  </Wrap>
);

const Tanks = () => (
  <Wrap>
    <rect x="12" y="14" width="24" height="24" rx="3" />
    <path d="M12 20h24M12 32h24" />
    <path d="M18 10v4M30 10v4" />
    <circle cx="24" cy="26" r="3" />
  </Wrap>
);

const Corrosion = () => (
  <Wrap>
    <path d="M24 8l14 6v8c0 8-6 14-14 18-8-4-14-10-14-18v-8z" />
    <path d="M19 24l3.5 3.5L30 20" />
  </Wrap>
);

export const PROCESS_ICONS = {
  sandblasting: Sandblasting,
  shotblasting: ShotBlasting,
  painting: Painting,
  polyurea: Polyurea,
  tanks: Tanks,
  corrosion: Corrosion,
};

export const ProcessIcon = ({ name, className = "" }) => {
  const Icon = PROCESS_ICONS[name] || Sandblasting;
  return (
    <span className={className}>
      <Icon />
    </span>
  );
};
